var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeEndNoResponseVideoCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1666 14.9846V14.4284C22.1666 13.1138 21.0288 12.1665 19.7777 12.1665H11.2221C9.97102 12.1665 8.83325 13.1138 8.83325 14.4284V21.5713C8.83325 22.8859 9.97102 23.8332 11.2221 23.8332H19.7777C21.0288 23.8332 22.1666 22.8859 22.1666 21.5713V21.0144L24.7548 22.3083C25.0088 22.4352 25.2912 22.4952 25.5749 22.4824C25.8586 22.4696 26.1343 22.3846 26.3759 22.2353C26.6175 22.086 26.817 21.8775 26.9553 21.6295C27.0937 21.3815 27.1664 21.1023 27.1666 20.8183V15.1812C27.1664 14.8972 27.0937 14.6175 26.9553 14.3695C26.817 14.1215 26.6175 13.913 26.3759 13.7638C26.1343 13.6145 25.8586 13.5294 25.5749 13.5167C25.2912 13.5039 25.009 13.5638 24.7549 13.6908L22.1666 14.9846ZM16.0892 14.9106C15.7637 14.5851 15.2361 14.5851 14.9107 14.9106L13.244 16.5772C12.9186 16.9027 12.9186 17.4303 13.244 17.7558C13.5694 18.0812 14.0971 18.0812 14.4225 17.7558L14.6666 17.5117V20.4998C14.6666 20.9601 15.0397 21.3332 15.4999 21.3332C15.9602 21.3332 16.3333 20.9601 16.3333 20.4998V17.5117L16.5773 17.7558C16.9028 18.0812 17.4304 18.0812 17.7558 17.7558C18.0813 17.4303 18.0813 16.9027 17.7558 16.5772L16.0892 14.9106Z",
    fill: "#1E2131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeEndNoResponseVideoCall);
export default __webpack_public_path__ + "static/media/me-end-no-response-video-call.a420912793e88a6f168a3cbe6aee6b18.svg";
export { ForwardRef as ReactComponent };